/* Match the existing product-form popup when WeUpsell adds one or more items. */
(() => {
  if (window.__weupsellPopupV2) return;
  window.__weupsellPopupV2 = true;
  // Only the product-page upsell slot (the "Complete the look" bundle) should trigger the top banner + View cart.
  // Add buttons inside the cart drawer ("Others also bought") must be left entirely to the app.
  const selector = '.weupsell-product-page-upsell-slot .weupsell_add_cart_button';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cartUrl = root + 'cart.js';
  let snapshot = null, session = null, timer = null, polling = null;
  const nativeFetch = window.fetch.bind(window);
  const cart = () => nativeFetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' }).then(r => { if (!r.ok) throw Error('Cart request failed'); return r.json(); });
  const isAddUrl = u => { try { return /\/cart\/add(?:\.js)?\/?$/.test(new URL(String(u), location.href).pathname); } catch { return false; } };
  const count = c => (c && c.items || []).reduce((m, i) => (m[i.key] = i.quantity, m), {});
  const delta = (oldCart, newCart) => { const old = count(oldCart); return (newCart.items || []).filter(i => i.quantity > (old[i.key] || 0)); };
  function ready() {
    const form = document.querySelector('product-form');
    return form && typeof form.showAddedPopup === 'function' ? form : null;
  }
  function complete(s) {
    if (!s || session !== s || s.working) return;
    s.working = true;
    cart().then(after => {
      if (session !== s) return;
      const added = s.before ? delta(s.before, after) : [];
      if (!added.length && !s.responseItems.length) { s.working = false; return; }
      const items = added.length ? added : s.responseItems;
      const signature = items.map(i => `${i.key || i.variant_id || i.id}:${i.quantity}`).join(',');
      if (signature !== s.signature) { s.signature = signature; s.changedAt = Date.now(); }
      if (Date.now() - s.changedAt < 650) { s.working = false; return; }
      clearInterval(polling); clearTimeout(timer); polling = null; timer = null;
      session = null;
      snapshot = after;
      const form = ready();
      if (form) form.showAddedPopup(items);
      else refreshHeader();
    }).catch(() => { s.working = false; }).finally(() => { s.working = false; });
  }
  function refreshHeader() {
    const form = ready();
    if (form && typeof form.refreshCartInBackground === 'function') { form.refreshCartInBackground(); return; }
    nativeFetch(`${location.pathname}?sections=cart-icon-bubble`, { credentials: 'same-origin' }).then(r => r.json()).then(sections => {
      const link = document.getElementById('cart-icon-bubble');
      if (!link || !sections['cart-icon-bubble']) return;
      const next = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.cart-count-bubble');
      const cur = link.querySelector('.cart-count-bubble');
      if (next && cur) { if (cur.innerHTML !== next.innerHTML) cur.innerHTML = next.innerHTML; }
      else if (next) link.appendChild(document.importNode(next, true));
      else if (cur) cur.remove();
    }).catch(() => {});
  }
  function arm() {
    if (session) return;
    const s = { before: snapshot, responseItems: [], signature: null, changedAt: Date.now(), working: false };
    session = s;
    const cls = customElements.get('product-form');
    if (cls && typeof cls.suppressAutoOpen === 'function') cls.suppressAutoOpen();
    // Snapshot is continuously refreshed before click, not first fetched after the app updates the cart.
    if (!s.before) cart().then(before => { if (session === s && !s.before) s.before = before; }).catch(() => {});
    polling = setInterval(() => complete(s), 250);
    timer = setTimeout(() => { if (session === s) { clearInterval(polling); polling = null; session = null; refreshHeader(); cart().then(c => { snapshot = c; }).catch(() => {}); } }, 12000);
  }
  // composedPath() also sees buttons rendered inside an app's shadow DOM.
  const hit = e => {
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [e.target];
    const btn = path.find(n => n && n.matches && n.matches(selector));
    return btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true';
  };
  document.addEventListener('pointerdown', e => { if (hit(e)) arm(); }, true);
  document.addEventListener('click', e => { if (hit(e)) arm(); }, true);
  function receive(data) {
    if (!session || !data || data.status) return;
    const items = Array.isArray(data.items) ? data.items : (data.id ? [data] : []);
    if (items.length) { session.responseItems = items; session.changedAt = Date.now(); }
  }
  // Observe the actual WeUpsell add response; do not block or replace its request.
  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const result = nativeFetch(input, init);
    if (isAddUrl(url)) result.then(r => { if (r.ok) r.clone().json().then(receive).catch(() => {}); }).catch(() => {});
    return result;
  };
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (isAddUrl(url)) this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300) {
        try { receive(JSON.parse(this.responseText)); } catch(e) {}
      }
    });
    return originalOpen.apply(this, arguments);
  };
  cart().then(c => { if (!session) snapshot = c; }).catch(() => {});
  // Keep a recent baseline even if the upsell widget renders late.
  setInterval(() => {
    if (session || document.hidden) return;
    cart().then(c => { if (!session) snapshot = c; }).catch(() => {});
  }, 2500);
})();

/* Header icon guard: the cart drawer must only open from the cart icon / "View cart".
   Taps on the hamburger, wishlist heart, account and country icons are ignored by the cart drawer.
   Debug: run `window.__cartGuardDebug = true` in the console, tap an icon, and see which function tried to open the cart. */
(() => {
  if (window.__menuCartGuard) return;
  window.__menuCartGuard = true;
  const menuSel = 'header-drawer, #Details-menu-drawer-container, a.header__icon--account, .header__icon--search';
  const cartSel = '#cart-icon-bubble, .header__icon--cart, #cart-notification-button, .atc-popup__view';
  let blockUntil = 0;
  const wrap = (obj, key) => {
    if (!obj || typeof obj[key] !== 'function' || obj[key].__menuGuard) return;
    const orig = obj[key];
    const guarded = function () {
      if (Date.now() < blockUntil) { if (window.__cartGuardDebug) console.warn('[cart guard] blocked ' + key, new Error().stack); return; }
      return orig.apply(this, arguments);
    };
    guarded.__menuGuard = true;
    try { obj[key] = guarded; } catch (e) {}
  };
  const install = () => {
    wrap(document.querySelector('cart-drawer'), 'open');
    wrap(window.WeUpsellCart, 'open');
    wrap(window.WeUpsellCart, 'toggle');
    wrap(window, 'weupsellOpenStaticCartDrawer');
  };
  const closeCart = () => {
    const d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active') && typeof d.close === 'function') d.close();
  };
  const onMenu = e => {
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [e.target];
    const isEl = (n, sel) => n && n.matches && n.matches(sel);
    if (path.some(n => isEl(n, cartSel)) || !path.some(n => isEl(n, menuSel))) return;
    blockUntil = Date.now() + 1200;
    install();
    // Safety net for apps that open their drawer by toggling classes instead of calling a function.
    [0, 60, 200, 450, 800].forEach(ms => setTimeout(closeCart, ms));
  };
  ['pointerdown', 'touchstart', 'click'].forEach(t => document.addEventListener(t, onMenu, true));
  install();
  setTimeout(install, 1500);
  setTimeout(install, 4000);
})();

/* Header icon rescue: if another script swallows a tap on the hamburger or account icon,
   perform that icon's own action so the icon still does what it should. */
(() => {
  if (window.__headerIconRescue) return;
  window.__headerIconRescue = true;
  let last = 0;
  const closest = (e, sel) => {
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [e.target];
    return path.find(n => n && n.matches && n.matches(sel));
  };
  const rescue = e => {
    const now = Date.now();
    if (now - last < 500) return;           // pointerup + click are one tap
    const menuBtn = closest(e, 'header-drawer > details > summary');
    const account = closest(e, 'a.header__icon--account');
    if (menuBtn) {
      last = now;
      const details = menuBtn.parentNode, drawer = menuBtn.closest('header-drawer');
      const wasOpen = details.hasAttribute('open') && details.classList.contains('menu-opening');
      setTimeout(() => {
        if (!drawer) return;
        if (!wasOpen) {
          if (details.hasAttribute('open') || details.classList.contains('menu-opening')) return; // opened normally
          details.setAttribute('open', '');
          if (typeof drawer.openMenuDrawer === 'function') drawer.openMenuDrawer(menuBtn);
          menuBtn.setAttribute('aria-expanded', 'true');
        } else if (details.classList.contains('menu-opening')) {                                  // close was swallowed
          if (typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(e, menuBtn);
          menuBtn.setAttribute('aria-expanded', 'false');
        }
      }, 450);
    } else if (account && e.type === 'click') {
      last = now;
      setTimeout(() => { if (e.defaultPrevented && account.href) location.href = account.href; }, 0);
    }
  };
  ['pointerup', 'click'].forEach(t => window.addEventListener(t, rescue, true));
})();